import { ConnectStores } from "lib/core/store"
import { DESIGN } from "path/constants"
import DownloadsList from "path/downloads/components/DownloadsList"

const StepDownloads = ({
  downloads,
  showControls,
  showAddDownload,
  saveDownload,
  deleteDownload
}) =>
  (!!downloads && downloads.length) || showAddDownload ? (
    <div className="StepDownloads Step__Ancillary__Block">
      <DownloadsList
        downloads={downloads}
        showControls={showControls}
        showAddDownload={showAddDownload}
        onAdd={saveDownload}
        onDelete={deleteDownload}
      />
    </div>
  ) : null

StepDownloads.displayName = "StepDownloads"

const mapStateToProps = function (state, ownProps) {
  let { permissions } = ownProps
  const { downloads, content } = state.stepStore.state
  const { saveDownload, deleteDownload } = state.stepDownloadsAdminStore.action
  if (permissions == null) {
    permissions = state.resourceStore.request.permissions()
  }

  const showControls =
    permissions && permissions.can_edit && ownProps.mode === DESIGN

  // downloads are replaced in blocks content, which is the only content type going forward,
  // so step must have legacy content to create new downloads
  const showAddDownload =
    showControls && state.stepStore.request.getStepHasLegacyContent()

  return _.assign(
    {},
    {
      downloads,
      showControls,
      showAddDownload,
      saveDownload,
      deleteDownload
    },
    ownProps
  )
}

const stores = [
  { store: "step", watch: ["downloads"] },
  { store: "resource" },
  { store: "stepDownloadsAdmin" }
]

export default ConnectStores(StepDownloads, stores, {}, mapStateToProps)
